import comp from "./AssessmentToolV2";
export default comp;
